import { useRef, useState } from "react";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import { Ion } from "@/components/Ion";
import { getToken } from "@/lib/api";
import { inputCls } from "@/components/quote/QuoteParts";
import { Thumb, shrink } from "@/components/quote/PhotoScan";

const BASE = process.env.REACT_APP_BACKEND_URL;

// Up to 3 close-up reference photos with real sizes; every photo scan in this quote is scaled from them.
export const Calibration = ({ refs, setRefs }) => {
  const [busy, setBusy] = useState(false);
  const ref = useRef(null);
  const pick = async (e) => {
    const f = e.target.files?.[0]; e.target.value = "";
    if (!f) return;
    setBusy(true);
    try {
      const fd = new FormData(); fd.append("file", await shrink(f), "ref.jpg");
      const r = await fetch(`${BASE}/api/quote-builder/calibration-photo`, { method: "POST", headers: { Authorization: `Bearer ${getToken()}` }, body: fd });
      const j = await r.json().catch(() => ({}));
      if (!r.ok) throw new Error(typeof j.detail === "string" ? j.detail : "Upload failed");
      setRefs((x) => [...x, { id: j.id, label: "" }]);
    } catch (err) { toast.error(err.message); } finally { setBusy(false); }
  };
  return (
    <div className="mb-3 rounded-[12px] border border-[#333] bg-[#1A1A1A] p-3" data-testid="calibration">
      <div className="flex items-center justify-between gap-3">
        <div>
          <p className="flex items-center gap-2 text-[13px] font-extrabold"><Ion name="locate-outline" size={16} color="#4CCC06" />Calibrate this job {refs.length > 0 && <span className="rounded-full bg-[#4CCC06] px-2 py-0.5 text-[10px] text-black" data-testid="calibration-count">{refs.length}/3</span>}</p>
          <p className="mt-0.5 text-[11px] leading-4 text-[#A0A0A0]">Take a close-up of one item and type its real size. Every wider photo in this quote is scaled from it.</p>
        </div>
        {refs.length < 3 && <button onClick={() => ref.current?.click()} disabled={busy} data-testid="calibration-add" className="flex shrink-0 items-center gap-1.5 rounded-full border border-[#4CCC06] px-3 py-2 text-[11px] font-extrabold text-[#4CCC06] disabled:opacity-50">{busy ? <Loader2 size={12} className="animate-spin" /> : <Ion name="camera-outline" size={13} color="#4CCC06" />}ADD REFERENCE</button>}
        <input ref={ref} type="file" accept="image/*" className="hidden" onChange={pick} data-testid="calibration-input" />
      </div>
      {refs.map((r, i) => (
        <div key={r.id} className="mt-2.5 flex items-center gap-2.5" data-testid={`calibration-ref-${i}`}>
          <Thumb id={r.id} />
          <input className={`${inputCls} flex-1`} value={r.label} onChange={(e) => setRefs((x) => x.map((y) => (y.id === r.id ? { ...y, label: e.target.value } : y)))}
            placeholder="What is it and its real size, e.g. upper cabinet door 15 x 30 in" data-testid={`calibration-label-${i}`} />
          <button onClick={() => setRefs((x) => x.filter((y) => y.id !== r.id))} className="p-1.5" aria-label="Remove" data-testid={`calibration-remove-${i}`}><Ion name="trash-outline" size={15} color="#EF4444" /></button>
        </div>
      ))}
    </div>
  );
};
